import { Context, createContext, FC, ReactElement, ReactNode, useEffect, useMemo, useState } from 'react';
import { ROLE } from '../constants/constants';
import { getFromLocalStorage, removeFromLocalStorage, setToLocalStorage } from '../utils/storage.util';

interface UserRoleContextProps {
	role: string | undefined;
	setRole: (role: string) => void;
}

const UserRoleContext: Context<UserRoleContextProps> = createContext<UserRoleContextProps>({
    role: ROLE.USER,
    setRole: (role: string) => {}
});

const UserRoleProvider: FC<{ children: ReactNode }> = ({ children }): ReactElement => {
    const [role, setRole] = useState((): string | undefined => {
        const savedRole: string | null = getFromLocalStorage('authRole');
        return savedRole ? savedRole : undefined;
    });

    useEffect((): void => {
        if (role) {
            setToLocalStorage('authRole', role);
        } else {
            removeFromLocalStorage('authRole');
        }
    }, [role]);

    const value: UserRoleContextProps = useMemo((): UserRoleContextProps => ({ role, setRole }), [role]);
    
    return (
        <UserRoleContext.Provider value={value}>
            {children}
        </UserRoleContext.Provider>
    );
}

export { UserRoleContext, UserRoleProvider };
export type { UserRoleContextProps };

